import { TrackerManager } from "@litres-libs/tracker-manager";
import type {
  BrandIdentitySubscriptionResponseSerializer as IUserBrandIdentity,
  ShortLitResSubscriptionSerializer,
  UserPartnerSubscriptionsSerializer,
} from "@litres-libs/types";
import type { ISubscriptionWithBranding } from "./interfaces";

export const getAvailableSubscriptions = (
  subscription: ShortLitResSubscriptionSerializer,
  partner_subscriptions: UserPartnerSubscriptionsSerializer,
  userBrandIdentities: IUserBrandIdentity[] = []
): ISubscriptionWithBranding[] => {
  const userBrandIdentitiesMap = new Map(
    userBrandIdentities.map(item => [item.sub_id, item.brand_identity])
  );
  const availabilitySubscriptions = partner_subscriptions.subscriptions.filter(
    sub => (sub.is_active || sub.is_in_grace_period) && sub.partner !== "litres"
  );

  if (subscription.is_active) {
    availabilitySubscriptions.push({
      sub_id: 0,
      is_active: true,
      partner: "litres",
      token: "litres",
      host: "subscription.litres.ru",
      type: "text",
      start_date: "",
      valid_till: "",
      is_in_grace_period: false,
    });
  }

  const uniqSubscriptions = new Set();
  return availabilitySubscriptions
    .filter(sub => {
      if (uniqSubscriptions.has(sub.token)) {
        return false;
      }
      uniqSubscriptions.add(sub.token);
      return true;
    })
    .map(sub => {
      const { sub_id, token, start_date, host } = sub;
      let brandIdentity = userBrandIdentitiesMap.get(sub_id);
      if (sub.sub_id === 0) {
        brandIdentity = {
          name_ru: "Литрес Подписка",
          name: "Litres Subscription",
          primary_color: "#FF4C00",
        };
      }

      return {
        token,
        host: host ?? "/",
        // Если бэкенд не вернёт брендирование какой-то из подписок или часть полей, то используем значения по-умолчанию
        name_ru: brandIdentity?.name_ru ?? `Подписка #${sub_id}`,
        name: brandIdentity?.name ?? `Subscription #${sub_id}`,
        short_name_ru: brandIdentity?.short_name_ru,
        short_name: brandIdentity?.short_name,
        primary_color: brandIdentity?.primary_color ?? "#000000",
        order: +(start_date ? new Date(start_date) : new Date()),
      };
    })
    .sort((a, b) => b.order - a.order);
};

const TM = TrackerManager.getInstance();

export const trackerOpenSubscriptionSwitcher = (): void => {
  TM.sendEvent(["LITRES_TRACKER"], {
    eventType: "subscription_switcher_view",
    params: {},
  });
};

export const trackerClickItemSubscriptionSwitcher = (host: string): void => {
  TM.sendEvent(["LITRES_TRACKER"], {
    eventType: "subscription_switcher_item_click",
    params: {
      domain: host,
    },
  });
};
